export default "__VITE_ASSET__ClKc8Rm0__"